<template>
  <div>
    <div
        class="tabulator-css"
        ref="reportTable"
        :class="vizCount > 1 ? 'multi-viz' : ($store.state.bannerStatus ? 'r1c2true' : 'r1c2false')"
    ></div>
    <!--    <div class="record-count">
          Total Filtered Records: {{ totalFilteredRecords }}
        </div>-->
  </div>
</template>

<script>
import Tabulator from "tabulator-tables";
import "tabulator-tables/dist/css/tabulator.min.css";
import {inrFormatterV2} from "@/common/functions";
// import {numberFormat} from "@/common/functions";
import XLSX from "xlsx/dist/xlsx.full.min.js";

window.XLSX = XLSX; // 👈 required for Tabulator xlsx download


export default {
  name: "TabulatorReportTable",
  props: {
    viz1: {
      type: Object,
      required: true,
    },
    tabulatorData: [],
    filters: Object,
    vizCount:Number
  },
  data() {
    return {
      tableData: [],
      totalFilteredRecords: 0,
      tabulatorInstance: null,
      searchTerm: "",
      sortedData: [],
      sortHistory: [],
      isSorting: false,
    };
  },
  watch: {
    tabulatorData: {
      handler(newData) {
        if (this.tabulatorInstance) {
          this.tabulatorInstance.replaceData(newData);
          // Apply search filter if there's a search term
          if (this.searchTerm) {
            this.handleSearch();
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    addSerialNumbers(data) {
      return data.map((row, index) => {
        const sanitizedRow = {};

        Object.keys(row).forEach(key => {
          sanitizedRow[key] =
              row[key] === null || row[key] === undefined ? '' : row[key];
        });

        return {
          slNo: index + 1,
          ...sanitizedRow,
        };
      });
    },
    downloadExcel(fileNameFromViz) {
      if (!this.tabulatorInstance) return;

      const fileName = fileNameFromViz + ".xlsx";

      // Get exactly what user sees (filtered + sorted)
      const visibleData = this.tabulatorInstance.getData("active");

      // Optional: add serial numbers
      const dataWithSlNo = this.addSerialNumbers(visibleData);

      // Temporarily add Sl.No column
      const originalColumns = this.tabulatorInstance.getColumns().map(c =>
          c.getDefinition()
      );

      this.tabulatorInstance.addColumn(
          { title: "Sl.No", field: "slNo", hozAlign: "center" },
          true
      );

      this.tabulatorInstance.replaceData(dataWithSlNo);

      // Download as XLSX
      this.tabulatorInstance.download("xlsx", fileName, {
        sheetName: "Data",
      });

      // Restore table
      this.tabulatorInstance.setColumns(originalColumns);
      this.tabulatorInstance.replaceData(visibleData);
    },
    setFilter(query) {
      if (!query) {
        this.tabulatorInstance.clearFilter();
        return;
      }

      const searchTerm = query.toLowerCase();

      // Custom filter function that checks all fields
      this.tabulatorInstance.setFilter((data) => {
        // Search through all properties of the row data
        return Object.values(data).some(value => {
          if (value === null || value === undefined) return false;
          return String(value).toLowerCase().includes(searchTerm);
        });
      });
    },

    clearFilter() {
      this.tabulatorInstance.clearFilter();
    },
    heatmapFormatter(cell) {
      const value = cell.getValue();
      const col = cell.getColumn().getDefinition();

      if (value === null || value === undefined || isNaN(value)) {
        return value;
      }

      // Read thresholds and default color
      const params = col.formatterParams || {};
      const thresholds = params.thresholds || [];
      let backgroundColor = params.defaultColor || "transparent";

      const minThreshold = thresholds.find(t => t.level === "min");
      const midThreshold = thresholds.find(t => t.level === "mid");

      if (minThreshold && value <= minThreshold.value) {
        backgroundColor = minThreshold.color;
      } else if (midThreshold && value <= midThreshold.value) {
        backgroundColor = midThreshold.color;
      } else {
        backgroundColor = params.defaultColor;
      }

      // Format value
      const submenuParam = this.$route.params.submenuId;
      const displayValue = inrFormatterV2(value, submenuParam);

      // Tooltip content (can include threshold info if you like)
      const tooltipText = `Value: ${displayValue}`;

      return `<div style="
    background-color: ${backgroundColor};
    padding: 4px;
    border-radius: 3px;
    text-align: center;
  " title="${tooltipText}">${displayValue}</div>`;
    },
    updateKeyValue(arr) {
      let submenuParam = this.$route.params.submenuId;
      console.log("submenuParam", submenuParam);

      // Handle both top-level and nested columns
      const processColumn = (col) => {
        // If column has nested columns, process them first
        if (col.columns) {
          return {
            ...col,
            columns: col.columns.map(processColumn),
            headerHozAlign: 'center'
          };
        }

        // Apply formatters based on column configuration
        if (col.formatter === 'customTickCrossFormatter') {
          return {
            ...col,
            formatter: this.customTickCrossFormatter,
            sorter: (a, b) => a - b,
            headerHozAlign: 'center'
          };
        } else if (col.formatter === 'numberSystem') {
          return {
            ...col,
            formatter: (cell) => {
              const value = cell.getValue();
              return inrFormatterV2(value, submenuParam);
            },
            headerHozAlign: 'center'
          };
        } else if (col.formatter === 'star') {
          return {
            ...col,
            formatter: 'star',
            headerHozAlign: 'center'
          };
        } else if (col.formatter === 'progress') {
          return {
            ...col,
            formatter: (cell) => {
              const tableData = cell.getTable().getData();
              const field = cell.getField();
              const values = tableData.map(row => row[field]).filter(val => val !== undefined && val !== null);
              const min = values.length > 0 ? Math.min(...values) : 0;
              const max = values.length > 0 ? Math.max(...values) : 1;
              const value = cell.getValue() || 0;
              const percentage = min === max ? 100 : ((value - min) / (max - min)) * 100;

              return `
            <div style="
              position: relative;
              width: 100%;
              height: 20px;
              background: #f0f0f0;
              border-radius: 3px;
              overflow: hidden;
            ">
              <div style="
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
                width: ${percentage}%;
                background: #468ad0;
                transition: width 0.3s;
              "></div>
              <div style="
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
                color: ${percentage > 50 ? 'white' : 'black'};
              ">
                ${value}${col.suffix || ''}
              </div>
            </div>
          `;
            },
            headerHozAlign: 'center'
          };
        } else if (col.field === 'hyperlink') {
          return {
            ...col,
            formatter: (cell) => {
              const value = cell.getValue();
              return value
                  ? `<a href="${value}" target="_blank" style="color:#468ad0; text-decoration:underline;">
             ${this.viz1.viz_specific6}
           </a>`
                  : '';
            },
            headerHozAlign: 'start'
          };
        } else if (col.field === 'menulink') {
          return {
            ...col,
            title: 'Sub Menu', // or keep col.title if you want dynamic
            formatter: (cell) => {
              const rowData = cell.getRow().getData();
              const link = rowData.menulink;
              const displayText = col.displayName ? rowData[col.displayName] : link;

              return link
                  ? `<a href="${link}" target="_blank" style="color:#468ad0; text-decoration:underline;">
             ${displayText || link}
           </a>`
                  : (displayText || '');
            },
            headerHozAlign: 'start'
          };
        } if (col.formatter === 'heatmap') {
          return {
            ...col,
            formatter: this.heatmapFormatter,
            headerHozAlign: 'center'
          };
        }

        // Default case for columns without specific formatters
        return {
          ...col,
          formatter: (cell) => {
            const value = cell.getValue();
            if (isNaN(value)) {
              return value;
            }
            return value;
          },
          headerHozAlign: 'center'
        };
      };

      return arr.map(processColumn);
    },
    async fetchData() {
      try {
        // const dataSqlId = this.viz1.datasqlId;
        // const response = await axios.post(`/api/fetchDataWithParam/${dataSqlId}/CommonVizClass`, this.filters);
        this.tableData = this.tabulatorData
        this.totalFilteredRecords = this.tableData.length;

        // Rebuild Tabulator with new data
        if (this.tabulatorInstance) {
          this.tabulatorInstance.replaceData(this.tableData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    loadTabulatorData(newData) {
      if (this.tabulatorInstance) {
        this.tabulatorInstance.replaceData(newData);
      }
    },
    customTickCrossFormatter(cell) {
      const value = cell.getValue();
      let output = '';

      switch (value) {
        case 5:
          output = `<span class="bold-tick">&#10003;&#10003;</span>`; // Bold tick
          break;
        case 4:
          output = `<span class="lite-tick">&#10003;</span>`; // Light tick
          break;
        case 3:
          output = `<span class="dash">&#9866;</span>`; // Dash for value 3
          break;
        case 2:
          output = `<span class="lite-cross">&#10005;</span>`; // Light cross
          break;
        case 1:
          output = `<span class="bold-cross">&#10006;&#10006;</span>`; // Bold cross
          break;
        default:
          output = `<span></span>`; // Empty if value is unrecognized
      }
      return output;
    },

    initializeTabulator() {
      this.tabulatorInstance = new Tabulator(this.$refs.reportTable, {
        data: this.tableData,
        layout: this.viz1.vizSpecific4,
        height: this.viz1.chartHeight + "px",
        columns: this.updateKeyValue(this.viz1.tab_report_json),
        columnHeaderSortMulti: false,
        rowContextMenu: (component, e) => {
          e.preventDefault();
          const rowData = component.getData();
          const filteredData = {};

          function processColumns(columns, rowData, filteredData) {
            columns.forEach(column => {
              // If the column has nested columns, process them recursively
              if (column.columns) {
                processColumns(column.columns, rowData, filteredData);
              }
              // If it's a regular column with a field
              else if (rowData[column.field] !== undefined) {
                if (column.original_key !== undefined) {
                  const key = column.original_key;
                  filteredData[key] = [rowData[column.field]];
                }
              }
            });
          }

          this.viz1.tab_report_json.forEach(column => {
            if (column.columns) {
              // If column has nested columns, process them
              processColumns(column.columns, rowData, filteredData);
            } else if (rowData[column.field] !== undefined) {
              // Use the title from tab_report_json if available, otherwise use field name
              if (column.original_key !== undefined) {
                const key = column.original_key;
                filteredData[key] = [rowData[column.field]];
              }
            }
          });

          // Create context menu element
          const menu = document.createElement("div");
          menu.className = "custom-context-menu";
          menu.style.position = "absolute";
          menu.style.left = `${e.clientX}px`;
          menu.style.top = `${e.clientY}px`;
          menu.style.background = "white";
          menu.style.border = "1px solid #ccc";
          menu.style.boxShadow = "2px 2px 5px rgba(0,0,0,0.2)";
          menu.style.zIndex = "10000";
          menu.style.padding = "5px 0";

          console.log(this.viz1.insight_navigator);
          // Add menu items from insightNavigator
          this.viz1.insight_navigator.navList.forEach(item => {
            const menuItem = document.createElement("div");
            menuItem.textContent = item.label;
            menuItem.style.padding = "5px 15px";
            menuItem.style.cursor = "pointer";

            menuItem.addEventListener("mouseenter", () => {
              menuItem.style.background = "#f0f0f0";
            });

            menuItem.addEventListener("mouseleave", () => {
              menuItem.style.background = "transparent";
            });

            menuItem.addEventListener("click", () => {
              const currentOrigin = window.location.origin;
              const fullUrl = `${currentOrigin}${item.url}`;
              const targetOrigin = new URL(fullUrl).origin;
              const newWindow = window.open(fullUrl, '_blank');

              // Prepare the data to send
              const messageData = {
                type: 'FILTER_DATA',
                payload: {clickedData: filteredData, globalFilters: this.filters},
                source: 'tabulator_report'
              };

              let attempts = 0;
              const maxAttempts = 10;

              const sendMessage = () => {
                if (newWindow.closed) return;

                if (attempts < maxAttempts) {
                  try {
                    newWindow.postMessage(messageData, targetOrigin);
                    console.log(`Attempt ${attempts + 1}: Message sent to ${targetOrigin}`);
                  } catch (e) {
                    console.error("PostMessage error:", e);
                  }
                  attempts++;
                  setTimeout(sendMessage, 200); // Retry every 200ms
                }
              };
              sendMessage();
              // Remove menu after click
              document.body.removeChild(menu);
            })
            menu.appendChild(menuItem);
          })
          // Add menu to body
          document.body.appendChild(menu);
          // Close menu when clicking elsewhere
          const closeMenu = (e) => {
            if (!menu.contains(e.target)) {
              document.body.removeChild(menu);
              document.removeEventListener("click", closeMenu);
            }
          };
          document.addEventListener("click", closeMenu);
          console.log(filteredData);
        },
        headerSortMulti: false,
        dataFiltered: (filters, rows) => {
          this.totalFilteredRecords = rows.length;
        },
      });
      this.tabulatorInstance.getColumns().forEach(col => {
        const colElement = col.getElement();
        colElement.addEventListener('click', () => {
          const field = col.getField();
          if (!field) return;
          this.isSorting = true;// Show loader

          /*console.log("col.getField():", field, "typeof:", typeof field);
          console.log("Clicked field:", field);
          console.log("Current sortHistory:", this.sortHistory);
*/
          // const existingIndex = this.sortHistory.findIndex(s => s.column.field === field);

          /* console.log("existingIndex", existingIndex);
           console.log("existingIndex", this.sortHistory.map(s => s.column.field === field));
 */
          this.$nextTick(() => {
            const existingIndex = this.sortHistory.findIndex(s => s.column.field === field);

            if (existingIndex > -1) {
              const currentSort = this.sortHistory[existingIndex];

              if (currentSort.dir === "asc") {
                // Change from asc to desc
                currentSort.dir = "desc";
                // Move to end of array (most recent)
                const [moved] = this.sortHistory.splice(existingIndex, 1);
                this.sortHistory.push(moved);
              } else if (currentSort.dir === "desc") {
                // Remove sort entirely (third click)
                this.sortHistory.splice(existingIndex, 1);
              }
            } else {
              // New sort (ascending)
              this.sortHistory.push({column: field, dir: "asc"});
            }
            const reversed = [...this.sortHistory].reverse();
            this.tabulatorInstance.setSort(reversed);

            setTimeout(() => {
              this.isSorting = false;
            }, 300);
          });

        });
      });
    },
    /*  downloadCSV() {
        if (this.tabulatorInstance) {
          this.tabulatorInstance.download("csv", "data.csv");
        } else {
          console.warn("Tabulator instance is not available.");
        }
      },*/
  },
  async mounted() {
    this.initializeTabulator();
    await this.fetchData();
  },
};
</script>

<style>
/* Add these styles for the search container */
.search-container {
  text-align: center;
  margin-bottom: 15px;
}

.search-input {
  padding: 8px 12px;
  margin-top: 4px;
  margin-bottom: -6px;
  width: 30%;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s;
}

.search-input:focus {
  border-color: #468ad0;
}

.record-count {
  font-weight: bold;
  margin-top: 5px;
  overflow: hidden;
}

.tabulator-css {
  background-color: white;
  border: 1px solid #ddd;
}

.bold-tick {
  font-weight: 900;
  color: green;
  width: 100px;
}

.lite-tick {
  font-weight: 200;
  color: green;
}

.bold-cross {
  color: red;
}

.lite-cross {
  color: red;
}

/*
.dash {
  font-weight: 900;
  color: #666; !* Gray dash for neutral value *!
}*/
.tabulator-edit-select-list {
  background-color: #ffffff;
}

.tabulator-edit-select-list .tabulator-edit-select-list-item:hover {
  background-color: lightgray;
  color: black;
}

.tabulator-edit-select-list .tabulator-edit-select-list-item.active:hover {
  background-color: red;
  color: white;
}

.tabulator-edit-select-list .tabulator-edit-select-list-item.active {
  background-color: #1e7e34;
  font-weight: bold;
  color: white;
}

.tabulator-col {
  background: black !important;
  color: white !important;
}

.tabulator .tabulator-header .tabulator-col.tabulator-sortable[aria-sort=none] .tabulator-col-content .tabulator-col-sorter {
  display: none;
}

.tabulator .tabulator-header .tabulator-col.tabulator-sortable[aria-sort=asc] .tabulator-col-content .tabulator-col-sorter .tabulator-arrow {
  border-top: none;
  border-bottom: 13px solid #1697cf;
}

.tabulator .tabulator-header .tabulator-col.tabulator-sortable[aria-sort=desc] .tabulator-col-content .tabulator-col-sorter .tabulator-arrow {
  border-bottom: none;
  border-top: 13px solid #1697cf !important;
}

.tabulator {
  color: black !important;
}

/* Loader styles */
.loader-overlay {
  position: absolute;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #468ad0;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.tabulator .tabulator-col-group .tabulator-col-title {
  text-align: center;
}

.r1c2true {
  max-height: 74vh;
}

.r1c2false {
  max-height: 81vh;
}

</style>